//
//
//

import React, { useEffect, useState } from "react";

import { Row, Col, Form, Button, Table, InputGroup } from "react-bootstrap";


function createTrip(desc, mon, tue, wed, thu, fri, sat, sun) {
  let trip = {
    active: true,
    freq: 'W', // W week, B biweekly, M month
    desc,
    mon,
    tue,
    wed,
    thu,
    fri,
    sat,
    sun
  }

  return trip;
}


function createWeekdayTrip(desc, mf) {
  return createTrip(desc, mf, mf, mf, mf, mf, 0, 0);
}


function createWeekendTrip(desc, sat, sun) {
  return createTrip(desc, 0, 0, 0, 0, 0, sat, sun);
}


// We may have templates for these someday, maybe personalized, not sure if worth the effort
// Start with standard fefault for now
function createDefault() {
  let trips = [];


  trips.push(createWeekdayTrip('Work', 40));
  trips.push(createWeekendTrip('Soccer', 30, 30));

  return trips;
}



export default function CarCalculator(props) {
  const [trips, setTrips] = useState(createDefault());
  const [mode, setMode] = useState(0); // View
  const [curItem, setCurItem] = useState(null);


  function createNewTrip(event) {
    event.preventDefault();

    let trip = createWeekdayTrip('New Trip', 10);
    setCurItem(trip);

    setMode(1);
  }

  function addTrip(item) {
    setMode(0);
  }

  function updateTrip(item) {
    setMode(0);
  }

  function cancelTrip(item) {
    setMode(0);
  }

  function doCalculation(event) {
    event.preventDefault();
  }


  return (
    <div>
      <Header onAddTrip={createNewTrip} />

      {mode === 1 && <TripEditor item={curItem} onUpdate={addTrip} onCancel={cancelTrip} />}
      {mode === 2 && <TripEditor item={curItem} onUpdate={updateTrip} onCancel={cancelTrip} />}

      {trips.map((t, i) => <Trip key={i} days={t} />)}

      <Form>
        <Button variant="primary" onClick={doCalculation}>Submit</Button>
        <Button variant="secondary" onClick={props.onCancel}>Cancel</Button>
      </Form>
    </div>


  );
}


function TripEditor(props) {

  function handleSave(event) {
    event.preventDefault();

    props.onUpdate('dog');
  }

  const text_style = {
    width: "2em"
  }

  //maxlength="3" size="3"

  return (
    <Form>
      <h3>Add trip here</h3>
      <Row>
        <Col>
          <input type="text" style={text_style} value='123' />
          <input type="text" style={text_style} value='123' />
          <input type="text" style={text_style} value='123' />
          <input type="text" style={text_style} value='123' />
          <input type="text" style={text_style} value='123' />
          <input type="text" style={text_style} value='123' />
          <input type="text" style={text_style} value='123' />
          <input type="text" style={text_style} value='123' />
        </Col>
      </Row>
      <Button variant="primary" onClick={handleSave}>Save</Button>
      <Button variant="secondary" onClick={props.onCancel}>Cancel</Button>

    </Form>
  );

}


function Header(props) {

  let day_header_style = {
    display: "inline-block",
    margin: "2px",
    width: "12%"
  }

  return (
    <Row>
      <Col xs={3}>Description</Col>
      <Col xs={7}>
        <span style={day_header_style}>M</span>
        <span style={day_header_style}>T</span>
        <span style={day_header_style}>W</span>
        <span style={day_header_style}>T</span>
        <span style={day_header_style}>F</span>
        <span style={day_header_style}>S</span>
        <span style={day_header_style}>SS</span>
      </Col>
      <Col><i className="fas fa-plus" title="Add Trip" onClick={props.onAddTrip} /></Col>
    </Row>
  );
}


function Trip(props) {

  return (
    <Row>
      <Col xs={3}>{props.days.desc}</Col>
      <Col xs={7}>
        <Day day={props.days.mon} />
        <Day day={props.days.tue} />
        <Day day={props.days.wed} />
        <Day day={props.days.thu} />
        <Day day={props.days.fri} />
        <Day day={props.days.sat} />
        <Day day={props.days.sun} />
      </Col>
      <Col>
      </Col>
    </Row>
  );

}


function Day(props) {

  let day_style = {
    display: "inline-block",
    margin: "2px",
    width: "12%"
  }


  return (
    <span style={day_style}>{props.day}</span>
  )
}